/**
 * CapabilitiesCell - Contact method icons
 */

import {
  EnvelopeIcon,
  GlobeAltIcon,
  PhoneIcon,
} from '@heroicons/react/24/outline';

interface CapabilitiesCellProps {
  hasPortal: boolean;
  hasMail: boolean;
  hasPhone: boolean;
}

export const CapabilitiesCell = ({
  hasPortal,
  hasMail,
  hasPhone,
}: CapabilitiesCellProps) => {
  const capabilities = [
    {
      enabled: hasPortal,
      icon: GlobeAltIcon,
      label: 'Portal',
      color: 'text-blue-600',
    },
    {
      enabled: hasMail,
      icon: EnvelopeIcon,
      label: 'Mail',
      color: 'text-emerald-600',
    },
    {
      enabled: hasPhone,
      icon: PhoneIcon,
      label: 'Phone',
      color: 'text-purple-600',
    },
  ];

  return (
    <div className="flex items-center gap-2">
      {capabilities.map(({ enabled, icon: Icon, label, color }) => (
        <div
          key={label}
          className={enabled ? color : 'text-gray-300'}
          title={`${label}: ${enabled ? 'Available' : 'Not available'}`}
        >
          <Icon className="h-4 w-4" />
        </div>
      ))}
    </div>
  );
};
